import { render, staticRenderFns } from "./SidebarFooter.vue?vue&type=template&id=c29664c2&scoped=true&"
import script from "./SidebarFooter.vue?vue&type=script&lang=js&"
export * from "./SidebarFooter.vue?vue&type=script&lang=js&"
import style0 from "./SidebarFooter.vue?vue&type=style&index=0&id=c29664c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29664c2",
  null
  
)

export default component.exports